import { createContext, useContext, } from 'react';

export const MastheadDisplayedContext = createContext(true);
export const MastheadDisplayedProvider = MastheadDisplayedContext.Provider;
export const MastheadDisplayedConsumer = MastheadDisplayedContext.Consumer;

export default function useMastheadDisplayed() {
  return useContext(MastheadDisplayedContext);
}
